import { useTranslation } from "react-i18next";
import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import type { WorkflowType } from "./workflowReducer";
import clsx from "clsx";

interface Props {
  workflowType: WorkflowType;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderRadius: "2px",
      padding: theme.spacing(0.5, 1),
      textTransform: "uppercase",
      fontWeight: 700,
      fontSize: "0.75em",
      letterSpacing: ".3px",
    },
    generic: {
      backgroundColor: "#ECCFFF",
      color: "#694382",
    },
    substation: {
      backgroundColor: "#B3E5FC",
      color: "#23547B",
    },
  }),
);

export function WorkflowTypeChip(props: Props) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <span
      className={clsx(classes.root, {
        [classes.generic]: props.workflowType === "generic",
        [classes.substation]: props.workflowType === "substation",
      })}
    >
      {props.workflowType === "generic" ? t("workflows.generic") : t("workflows.substationSpecific")}
    </span>
  );
}
